<div class="steps-header mg-t10">
    <div class="step" [ngClass]="{ 'step--active': currentStep === 1, 'step--completed': currentStep > 1 }">
        <span class="step-index">1</span>
    </div>
    <div class="step" [ngClass]="{ 'step--active': currentStep === 2, 'step--completed': currentStep > 2 }">
        <span class="step-index">2</span>
    </div>
    <div class="step" [ngClass]="{ 'step--active': currentStep === 3 }">
        <span class="step-index">3</span>
    </div>
</div>

<div class="step-helper mg-t10" aria-live="polite">
    <div class="step-helper-title">
        <ng-container [ngSwitch]="currentStep">
            <span *ngSwitchCase="1">{{ 'WHEEL_CHARACTERISTICS.STEP_1_TITLE' | translate }}</span>
            <span *ngSwitchCase="2">{{ 'WHEEL_CHARACTERISTICS.STEP_2_TITLE' | translate }}</span>
            <span *ngSwitchDefault>{{ 'WHEEL_CHARACTERISTICS.STEP_3_TITLE' | translate }}</span>
        </ng-container>
    </div>
    <div class="step-helper-text">
        <ng-container [ngSwitch]="currentStep">
            <span *ngSwitchCase="1">{{ 'WHEEL_CHARACTERISTICS.STEP_1_DESC' | translate }}</span>
            <span *ngSwitchCase="2">{{ 'WHEEL_CHARACTERISTICS.STEP_2_DESC' | translate }}</span>
            <span *ngSwitchDefault>{{ 'WHEEL_CHARACTERISTICS.STEP_3_DESC' | translate }}</span>
        </ng-container>
    </div>
</div>

<div class="form-group mg-t10" *ngIf="SeasonShow">
    <label for="season-select">{{'WHEEL_CHARACTERISTICS.1' | translate}}<span
            class="mandatory-asterisk">*</span></label>
    <div class="season-cards-container" role="radiogroup" [attr.aria-label]="'WHEEL_CHARACTERISTICS.1' | translate">
        <button type="button" class="season-card"
            [ngClass]="{'season-card-selected': Season === SeasonTypeMaintenance.SUMMER}"
            [attr.aria-pressed]="Season === SeasonTypeMaintenance.SUMMER"
            [attr.aria-label]="'SEASON_TYPE.' + SeasonTypeMaintenance.SUMMER | translate"
            (click)="setSeason(SeasonTypeMaintenance.SUMMER)">
            <img src="assets/icons/summer_icon.svg" [alt]="'SEASON_TYPE.' + SeasonTypeMaintenance.SUMMER | translate"
                loading="lazy">
            {{'SEASON_TYPE.' + SeasonTypeMaintenance.SUMMER | translate}}
        </button>
        <button type="button" class="season-card"
            [ngClass]="{'season-card-selected': Season === SeasonTypeMaintenance.WINTER}"
            [attr.aria-pressed]="Season === SeasonTypeMaintenance.WINTER"
            [attr.aria-label]="'SEASON_TYPE.' + SeasonTypeMaintenance.WINTER | translate"
            (click)="setSeason(SeasonTypeMaintenance.WINTER)">
            <img src="assets/icons/winter-icon.svg" [alt]="'SEASON_TYPE.' + SeasonTypeMaintenance.WINTER | translate"
                loading="lazy">
            {{'SEASON_TYPE.' + SeasonTypeMaintenance.WINTER | translate}}
        </button>
        <button type="button" class="season-card"
            [ngClass]="{'season-card-selected': Season === SeasonTypeMaintenance.ALL_SEASON}"
            [attr.aria-pressed]="Season === SeasonTypeMaintenance.ALL_SEASON"
            [attr.aria-label]="'SEASON_TYPE.' + SeasonTypeMaintenance.ALL_SEASON | translate"
            (click)="setSeason(SeasonTypeMaintenance.ALL_SEASON)">
            <img src="assets/icons/4-seasons-icon.svg"
                [alt]="'SEASON_TYPE.' + SeasonTypeMaintenance.ALL_SEASON | translate" loading="lazy">
            {{'SEASON_TYPE.' + SeasonTypeMaintenance.ALL_SEASON | translate}}
        </button>
    </div>
</div>

<div *ngIf="TyreReadingTitle" class="label-title mg-t22">
    {{'WHEEL_CHARACTERISTICS.12' | translate}}
</div>

<div class="input-inline-group mg-t15">
    <div class="form-group flex-1">
        <label for="Width">{{'WHEEL_CHARACTERISTICS.2' | translate}}<span class="mandatory-asterisk">*</span></label>
        <app-select-by-keys-dropdown id="Width" [dataArray]="WidthArray" [selectedKey]="Width"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate" (optionEmitter)="setWidth($event)">
        </app-select-by-keys-dropdown>
    </div>
    <div class="form-group flex-1">
        <label for="Series">{{'WHEEL_CHARACTERISTICS.3' | translate}}<span class="mandatory-asterisk">*</span></label>
        <div [ngClass]="{ 'field-disabled-wrapper': !Width }">
            <app-select-by-keys-dropdown id="Series" [dataArray]="SeriesArray" [selectedKey]="Series"
                [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate" (optionEmitter)="setSeries($event)">
            </app-select-by-keys-dropdown>
        </div>
        <div *ngIf="!Width" class="field-hint">
            {{ 'WHEEL_CHARACTERISTICS.FILL_WIDTH_FIRST' | translate }}
        </div>
    </div>
    <div class="form-group flex-1">
        <label for="Diameter">{{'WHEEL_CHARACTERISTICS.4' | translate}}<span class="mandatory-asterisk">*</span></label>
        <div [ngClass]="{ 'field-disabled-wrapper': !Series }">
            <app-select-by-keys-dropdown id="Diameter" [dataArray]="DiameterArray" [selectedKey]="Diameter"
                [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate" (optionEmitter)="setDiameter($event)">
            </app-select-by-keys-dropdown>
        </div>
        <div *ngIf="!Series" class="field-hint">
            {{ 'WHEEL_CHARACTERISTICS.FILL_SERIES_FIRST' | translate }}
        </div>
    </div>
</div>

<div class="input-inline-group mg-t15">
    <div class="form-group flex-1">
        <label for="LoadIndex">{{'WHEEL_CHARACTERISTICS.5' | translate}}<span
                class="mandatory-asterisk">*</span></label>
        <div [ngClass]="{ 'field-disabled-wrapper': !Diameter }">
            <app-select-by-keys-dropdown id="LoadIndex" [dataArray]="LoadIndexArray" [selectedKey]="LoadIndex"
                [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate" (optionEmitter)="setLoadIndex($event)">
            </app-select-by-keys-dropdown>
        </div>
        <div *ngIf="!Diameter" class="field-hint">
            {{ 'WHEEL_CHARACTERISTICS.FILL_DIAMETER_FIRST' | translate }}
        </div>
    </div>
    <div class="form-group flex-1">
        <label for="SpeedIndex">{{'WHEEL_CHARACTERISTICS.6' | translate}}<span
                class="mandatory-asterisk">*</span></label>
        <div [ngClass]="{ 'field-disabled-wrapper': !LoadIndex }">
            <app-select-by-keys-dropdown id="SpeedIndex" [dataArray]="SpeedIndexArray" [selectedKey]="SpeedIndex"
                [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate" (optionEmitter)="setSpeedIndex($event)">
            </app-select-by-keys-dropdown>
        </div>
        <div *ngIf="!LoadIndex" class="field-hint">
            {{ 'WHEEL_CHARACTERISTICS.FILL_LOADINDEX_FIRST' | translate }}
        </div>
    </div>
</div>

<div class="checkbox-section">
    <div class="checkbox-container">
        <input type="checkbox" class="checkbox" id="IsAntiFlat" [checked]="IsAntiFlat" (change)="changeIsAntiFlat()"
            [attr.aria-label]="'WHEEL_CHARACTERISTICS.7' | translate" />
        <label for="IsAntiFlat">{{'WHEEL_CHARACTERISTICS.7' | translate}}</label>
    </div>
    <div class="checkbox-container">
        <input type="checkbox" class="checkbox" id="DidWeAlignTyres" [checked]="DidWeAlignTyres"
            (change)="changeDidWeAlignTyres()" [attr.aria-label]="'WHEEL_CHARACTERISTICS.8' | translate" />
        <label for="DidWeAlignTyres">{{'WHEEL_CHARACTERISTICS.8' | translate}}</label>
    </div>
    <div class="checkbox-container">
        <input type="checkbox" class="checkbox" id="DidWePermuteTyres" [checked]="DidWePermuteTyres"
            (change)="changeDidWePermuteTyres()" [attr.aria-label]="'WHEEL_CHARACTERISTICS.9' | translate" />
        <label for="DidWePermuteTyres">{{'WHEEL_CHARACTERISTICS.9' | translate}}</label>
    </div>
</div>

<div class="availability-note mg-t10">
    {{ 'WHEEL_CHARACTERISTICS.AVAILABILITY_NOTE' | translate }}
</div>

<div *ngIf="BrandMdelTitle" class="label-title mg-t22">
    {{'WHEEL_CHARACTERISTICS.13' | translate}}
</div>

<div class="form-group mg-t15">
    <label for="Brand">
        {{'WHEEL_CHARACTERISTICS.10' | translate}}<span class="mandatory-asterisk">*</span>
        <img *ngIf="loadingModels" class="img-loading-models" src="../../../assets/gifs/loading-spinner.gif" alt="" />
        <span *ngIf="loadingModels" class="loading-models-text">
            {{ 'WHEEL_CHARACTERISTICS.LOADING_MODELS' | translate }}
        </span>
    </label>
    <div [ngClass]="{ 'field-disabled-wrapper': loadingModels }">
        <app-select-by-keys-dropdown id="Brand" [loading]="loadingModels" [otherOption]="true" [dataArray]="BrandArray"
            [selectedKey]="Brand" [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate"
            (optionEmitter)="setBrand($event)">
        </app-select-by-keys-dropdown>
    </div>
    <div *ngIf="loadingModels && hasBasicDimensions" class="field-hint field-hint--info">
        {{ 'WHEEL_CHARACTERISTICS.LOADING_MODELS' | translate }}
    </div>
</div>

<div class="form-group mg-t15">
    <label for="Model">
        {{'WHEEL_CHARACTERISTICS.11' | translate}}<span class="mandatory-asterisk">*</span>
        <img *ngIf="loadingModels" class="img-loading-models" src="../../../assets/gifs/loading-spinner.gif" alt="" />
        <span *ngIf="loadingModels" class="loading-models-text">
            {{ 'WHEEL_CHARACTERISTICS.LOADING_MODELS' | translate }}
        </span>
    </label>
    <div [ngClass]="{ 'field-disabled-wrapper': loadingModels || !Brand }">
        <app-select-by-keys-dropdown id="Model" [loading]="loadingModels" [otherOption]="true"
            [dataArray]="BrandModelMap.get(Brand) ? BrandModelMap.get(Brand) : []" [selectedKey]="Model"
            [placeholder]="'WHEEL_CHARACTERISTICS.0' | translate" (optionEmitter)="setModel($event)">
        </app-select-by-keys-dropdown>
    </div>
    <div *ngIf="loadingModels && hasBasicDimensions" class="field-hint field-hint--info">
        {{ 'WHEEL_CHARACTERISTICS.LOADING_MODELS' | translate }}
    </div>
</div>

<div *ngIf="availableModelsCount > 0" class="helper-text mg-t10">
    {{ 'WHEEL_CHARACTERISTICS.AVAILABLE_MODELS_COUNT' | translate:{ count: availableModelsCount } }}
</div>

<div *ngIf="showNoModelsMessage" class="helper-text helper-text--warning mg-t6">
    {{ 'WHEEL_CHARACTERISTICS.NO_MODELS_FOR_DIMENSIONS' | translate }}
</div>

<div *ngIf="showModelsError" class="helper-text helper-text--error mg-t6">
    {{ modelsErrorKey | translate }}
    <button type="button" class="retry-button" (click)="retryLoadModels()">
        {{ 'WHEEL_CHARACTERISTICS.RETRY' | translate }}
    </button>
</div>

<div *ngIf="DotCodeTitle" class="label-title mg-t22">
    {{ 'WHEEL_CHARACTERISTICS.COMPLEMENTARY_INFO' | translate }}
</div>

<div class="form-group mg-t22">
    <label for="DotCode">{{ 'WHEEL_CHARACTERISTICS.DOT_CODE' | translate }}</label>
    <input id="DotCode" [(ngModel)]="DotCode" (ngModelChange)="setDotCode($event)" class="form-text-input" maxlength="4"
        [placeholder]="'WHEEL_CHARACTERISTICS.DOT_PLACEHOLDER' | translate" type="text"
        [disabled]="!hasBrandAndModel" />
    <div *ngIf="!hasBrandAndModel" class="field-hint">
        {{ 'WHEEL_CHARACTERISTICS.FILL_BRAND_MODEL_FIRST' | translate }}
    </div>
    <div *ngIf="dotCodeErrorKey" class="field-hint field-hint--error">
        {{ dotCodeErrorKey | translate }}
    </div>
</div>